import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3725835f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3725835f')) {
      api.createRecord('3725835f', component.options)
    } else {
      api.reload('3725835f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3725835f&", function () {
      api.rerender('3725835f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/monitor/redis/index.vue"
export default component.exports